import { inject, injectable } from 'inversify';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserClient } from '@client/entity/current-client-user/domain/model/current-client-user-client.model';
import type { CurrentClientUserStoreQuery } from '@client/entity/current-client-user/domain/store/current-client-user.store-query';

@injectable()
export class CurrentClientUserSelectedClientService {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserStoreQuery)
    private readonly currentClientUserStoreQuery: CurrentClientUserStoreQuery,
  ) {}

  public getSelectedClient(clientId?: string): CurrentClientUserClient | null {
    const clients = this.currentClientUserStoreQuery.getDefinedCurrentClientUserClients();
    if (!clients.length) {
      return null;
    }

    if (clientId) {
      return clients.find((client) => client.id === clientId) ?? null;
    }

    return this.currentClientUserStoreQuery.getSelectedClient() ?? clients[0];
  }
}
